<template>
  <svg
    viewBox="0 0 24 24"
    width="1.5em"
    height="1.5em"
    fill="currentColor"
    class="zds-icon bw_sBR X9n9TI DlJ4rT _5Yd-hZ HlZ_Tf I_qHp3"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="m23.807 11.497-3.365-3.735a.75.75 0 0 0-.557-.247H16.51V4.5a.75.75 0 0 0-.75-.75H3.007a.75.75 0 0 0-.75.75v12.008c0 .414.336.75.75.75h1.467a2.999 2.999 0 0 0 5.997 0h6.035a2.999 2.999 0 0 0 5.997 0h.746a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.193-.503M19.55 9.015l2.949 3.274v3.468h-.408c-.519-.896-1.477-1.506-2.587-1.506s-2.068.61-2.587 1.506h-.404v-.96l-.002-5.782zM3.758 5.25H15.01l.001 3.01v.005l.003 7.492H10.06c-.518-.896-1.476-1.506-2.586-1.506s-2.068.61-2.587 1.506H3.758zm3.716 13.5a1.5 1.5 0 1 1 0-2.998 1.5 1.5 0 0 1 0 2.998m12.031 0a1.5 1.5 0 1 1 0-2.998 1.5 1.5 0 0 1 0 2.998"
    ></path>
  </svg>
</template>

<script setup lang="ts"></script>
